import DOMPurify from "dompurify";

// Preserve mathematical markup and diagrams while removing executable HTML.
export function sanitizeStudyHtml(value) {
  let html=String(value ?? "");
  // Imported questions may contain entity-escaped tags around TeX. Decode before
  // sanitizing so neither literal tags nor newly decoded executable HTML survive.
  const decoder=document.createElement("textarea");
  for(let pass=0;pass<3;pass++) {
    const decoded=html.replace(/&(?:#[0-9]+|#x[0-9a-f]+|[a-z][a-z0-9]+);/gi,entity=>{
      decoder.innerHTML=entity;
      return decoder.value;
    });
    if(decoded===html)break;
    html=decoded;
  }
  return DOMPurify.sanitize(html, {
    USE_PROFILES: {html:true, svg:true, mathMl:true},
    FORBID_TAGS:["script","iframe","object","embed","form","input","button","style","foreignObject"],
    FORBID_ATTR:["srcdoc"],
    ALLOW_UNKNOWN_PROTOCOLS:false
  });
}
